"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOffsetBox = void 0;
var _react = require("react");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var offsetBoxArray = [];
var useOffsetBox = function useOffsetBox() {
  var isOpenOnFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var onClose = arguments.length > 1 ? arguments[1] : undefined;
  var onBlur = arguments.length > 2 ? arguments[2] : undefined;
  var isSelectOnBlur = arguments.length > 3 ? arguments[3] : undefined;
  var isMountedRef = (0, _react.useRef)(false);
  var dropContentRef = (0, _react.useRef)(null);
  var anchorRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var close = (0, _react.useCallback)(function () {
    setIsOpen(false);
  }, []);
  var open = (0, _react.useCallback)(function () {
    setIsOpen(true);
  }, []);
  var handleClose = (0, _react.useCallback)(function () {
    if (onClose) {
      onClose();
    }
    anchorRef.current && anchorRef.current.focus();
    close();
  }, [close, onClose]);
  var toggle = (0, _react.useCallback)(function () {
    if (isOpen) {
      handleClose();
    } else {
      open();
    }
  }, [handleClose, isOpen, open]);
  var isOffsetBoxEvent = (0, _react.useCallback)(function (event, anchorElement, dropContentElement) {
    if (event) {
      var _path;
      // Check if the event was inside the anchor button
      if (anchorElement === event.target || anchorElement !== null && anchorElement !== void 0 && anchorElement.contains(event.target)) return true;

      // Check if the event was inside the drop content by checking the event parents (path)
      var eventParentIndex = 0;
      var path = event.composedPath ? event.composedPath() : event.path;
      path = (_path = path) !== null && _path !== void 0 && _path.length ? path : event.target ? [event.target] : [];
      do {
        var _path2, _path3;
        var eventParent = (_path3 = path) === null || _path3 === void 0 ? void 0 : _path3[eventParentIndex];
        if (eventParent !== window && dropContentElement !== null && dropContentElement !== void 0 && dropContentElement.contains(eventParent)) return true;
        eventParentIndex++;
      } while (eventParentIndex < ((_path2 = path) === null || _path2 === void 0 ? void 0 : _path2.length));
    }
    return false;
  }, []);
  var getDropElementChildren = (0, _react.useCallback)(function (parentDropElement) {
    var children = [];
    offsetBoxArray.forEach(function (ob) {
      if (ob.anchorRef && parentDropElement !== null && parentDropElement !== void 0 && parentDropElement.contains(ob.anchorRef.current)) {
        children.push(ob);
      }
    });
    return children;
  }, []);
  var handleOffsetBoxBlur = (0, _react.useCallback)(function (event) {
    if (!(dropContentRef !== null && dropContentRef !== void 0 && dropContentRef.current)) return;
    if (event.key === 'Tab') {
      if (isSelectOnBlur && onClose) {
        onClose();
      }
      handleClose();
    }
    if (isOffsetBoxEvent(event, anchorRef.current, dropContentRef.current)) return;
    var offsetBoxChildren = getDropElementChildren(dropContentRef.current);
    for (var i = 0; i < offsetBoxChildren.length; i++) {
      if (isOffsetBoxEvent(event, offsetBoxChildren[i].anchorRef.current, offsetBoxChildren[i].dropContentRef.current)) return;
    }
    if (isMountedRef.current) {
      if (onBlur) {
        onBlur(event);
      }
      handleClose();
    }
  }, [anchorRef, handleClose, isOffsetBoxEvent, getDropElementChildren, onBlur, isSelectOnBlur, onClose]);
  var handleAnchorFocus = function handleAnchorFocus(event) {
    if (isOpenOnFocus) {
      setTimeout(function () {
        if (isMountedRef.current) {
          open();
        }
      }, 300);
    }
  };
  var handleAnchorKeyUp = function handleAnchorKeyUp(event) {
    switch (event.key) {
      case 'Enter':
      case 'ArrowDown':
        open();
        setTimeout(function () {
          var _dropContentRef$curre, _dropContentRef$curre2;
          var focusOn = (dropContentRef === null || dropContentRef === void 0 ? void 0 : (_dropContentRef$curre = dropContentRef.current) === null || _dropContentRef$curre === void 0 ? void 0 : _dropContentRef$curre.querySelector('input')) || (dropContentRef === null || dropContentRef === void 0 ? void 0 : (_dropContentRef$curre2 = dropContentRef.current) === null || _dropContentRef$curre2 === void 0 ? void 0 : _dropContentRef$curre2.querySelector('[tabindex="0"]'));
          focusOn === null || focusOn === void 0 ? void 0 : focusOn.focus();
        }, 300);
        break;
      case 'Escape':
        close();
        break;
      default:
        break;
    }
  };
  var handleOffsetBoxLeave = function handleOffsetBoxLeave(event) {
    var _anchorRef$current, _dropContentRef$curre3;
    if (event.relatedTarget.nodeName !== undefined && (anchorRef.current === event.relatedTarget || (_anchorRef$current = anchorRef.current) !== null && _anchorRef$current !== void 0 && _anchorRef$current.contains(event.relatedTarget) || dropContentRef.current === event.relatedTarget || (_dropContentRef$curre3 = dropContentRef.current) !== null && _dropContentRef$curre3 !== void 0 && _dropContentRef$curre3.contains(event.relatedTarget))) {
      return;
    }
    if (isMountedRef.current) {
      close();
    }
  };
  (0, _react.useEffect)(function () {
    isMountedRef.current = true;
    var index = offsetBoxArray.length;
    offsetBoxArray.push({
      id: index,
      anchorRef: anchorRef,
      dropContentRef: dropContentRef
    });
    return function () {
      offsetBoxArray = offsetBoxArray.filter(function (_ref) {
        var id = _ref.id;
        return id !== index;
      });
      isMountedRef.current = false;
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (isOpen) {
      var _document$querySelect;
      window.addEventListener('resize', close);
      window.addEventListener('scroll', close);
      (_document$querySelect = document.querySelector('#rootScroll')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.addEventListener('scroll', close);
    }
    return function () {
      var _document$querySelect2;
      window.removeEventListener('resize', close);
      window.removeEventListener('scroll', close);
      (_document$querySelect2 = document.querySelector('#rootScroll')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.removeEventListener('scroll', close);
    };
  }, [close, isOpen]);
  (0, _react.useEffect)(function () {
    document.addEventListener('click', handleOffsetBoxBlur);
    return function () {
      document.removeEventListener('click', handleOffsetBoxBlur);
    };
  }, [handleOffsetBoxBlur]);
  (0, _react.useEffect)(function () {
    var listener = function listener(event) {
      if (event.key === 'Tab' && event.shiftKey && event.target.getAttribute('data-value') === '1') {
        // Shift + Tab on first element will return focus to button
        anchorRef.current && anchorRef.current.focus();
      }
      setTimeout(function () {
        if (event.key === 'Escape') {
          close();
        } else if (event.key === 'Tab') {
          handleOffsetBoxBlur(event);
        }
      }, 0);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    document.addEventListener('keydown', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
      document.removeEventListener('keydown', listener);
    };
  }, [close, handleOffsetBoxBlur]);
  return {
    dropContentRef: dropContentRef,
    anchorRef: anchorRef,
    handleAnchorFocus: handleAnchorFocus,
    handleAnchorKeyUp: handleAnchorKeyUp,
    handleOffsetBoxLeave: handleOffsetBoxLeave,
    handleOffsetBoxBlur: handleOffsetBoxBlur,
    toggle: toggle,
    close: close,
    open: open,
    isOpen: isOpen
  };
};
exports.useOffsetBox = useOffsetBox;